const height = 96;

export default {
    height,
};
